import type { PathConfig } from '@react-navigation/native';

const parseSingleId = (value: string) => [value];

export const groupMembersLinking = {
  path: '/group-members',
  parse: {
    addressIds: parseSingleId,
    groupIds: parseSingleId,
  },
} satisfies PathConfig<object>;
